import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { realtimeDatabase } from './database/firebase';
import { ref, update, serverTimestamp } from 'firebase/database';
import Login from './pages/login/login';
import Intro from './pages/intro/intro';
import Game from './pages/game/game';
import UserPage from './pages/userpage/userpage';
import Admin from './admin/admin';
import DDDUI from './pages/dddUI/ddd';
import TournamentList from './pages/tournament/TournamentList';
import TournamentStructure from './pages/tournamentStructure/TournamentStructure';
import AllUsers from './pages/allusers/allusers';

function usePageBackground() {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;

    body.classList.remove('common-bg');

    switch (location.pathname) {
      case '/':
      case '/login':
        body.classList.add('common-bg');
        break;
      case '/game':
        body.classList.remove('rules-bg');
        body.classList.add('common-bg');
        break;
     
      case '/intro':
        body.classList.add("common-bg", "rules-bg");
        break;
      case '/admin':
        body.classList.add('common-bg');
        break;
      case '/thankyou':
        body.classList.add('common-bg');
        break;
      case '/game':
        body.classList.add('common-bg');
        break;
      case '/allusers':
        body.classList.add('common-bg');
        break;
      case '/thankyou':
        body.classList.add('common-bg');
        break;
      case '/tournament':
        body.classList.add('common-bg');
        break;
      case '/tournamentStructure':
        body.classList.add('common-bg');
        break;
      case '/userpage':
      case '/plan':
        body.classList.add('common-bg');
        break;
   
        default:
        break;
    }
  }, [location]); 
}


function AppContent() {
  usePageBackground();
  const navigate = useNavigate();

  useEffect(() => {
    const setUserOffline = () => {
      try {
        const ss = sessionStorage.getItem('userData');
        if (!realtimeDatabase || !ss) return;
        const u = JSON.parse(ss);
        if (!u?.sessionId || !u?.userId) return;
        const resetToOnline = sessionStorage.getItem('resetToOnlineOnUnload');
        if (resetToOnline === '1') {
          // User closed browser on gameover popup (live 1v1) without clicking Exit - reset to online
          update(ref(realtimeDatabase, `sessions/${u.sessionId}/users/${u.userId}`), { status: 'online', islive: true, live: true, timestamp: serverTimestamp() }).catch(() => {});
          sessionStorage.removeItem('resetToOnlineOnUnload');
        } else {
          update(ref(realtimeDatabase, `sessions/${u.sessionId}/users/${u.userId}`), { islive: false, live: false }).catch(() => {});
        }
      } catch (_) {}
    };
    window.addEventListener('beforeunload', setUserOffline);
    window.addEventListener('pagehide', setUserOffline);
    return () => {
      window.removeEventListener('beforeunload', setUserOffline);
      window.removeEventListener('pagehide', setUserOffline);
    };
  }, []);
   
     // Get initial image from sessionStorage or env variable
     const getInitialImage = () => {
       return sessionStorage.getItem("orgData") || process.env.REACT_APP_EM_LOGO;
     };
   
     // State for header config
     const [headerConfig, setHeaderConfig] = useState({
       imageUrl: getInitialImage(),
       backButtonRedirect: "/", // Default back button
       backButtonDisabled: false,
     });
   
     // Update both image and back button together (ONLY from Login)
     const updateHeader = useCallback(({ imageUrl, backButtonRedirect, backButtonDisabled }) => {
       setHeaderConfig((prev) => ({
         imageUrl: imageUrl !== undefined && imageUrl !== null ? imageUrl : prev.imageUrl,
         backButtonRedirect: backButtonRedirect || prev.backButtonRedirect,
         backButtonDisabled: backButtonDisabled !== undefined ? backButtonDisabled : prev.backButtonDisabled,
       }));
   
       // Store image in sessionStorage if provided
       if (imageUrl) sessionStorage.setItem("orgData", imageUrl);
     }, []);
   
   
     const handleBack = () => {
       const { backButtonRedirect, backButtonDisabled } = headerConfig;
       if (backButtonDisabled) return;
   
       if (backButtonRedirect.length > 20) {
         // Open in new tab (External Link)
         window.location.href = backButtonRedirect;
       } else {
         // Internal Navigation
         navigate(backButtonRedirect);
       }
     };
   
  return (
      <>
      <DDDUI imageUrl={headerConfig.imageUrl} onBack={handleBack} backButtonDisabled={headerConfig.backButtonDisabled}></DDDUI>
      <Routes>
        <Route path="/" element={<Login updateHeader={updateHeader}/>} />
        <Route path="/login" element={<Login updateHeader={updateHeader}/>} />
        <Route path="/intro" element={<Intro updateHeader={updateHeader}/>} />
        <Route path="/game" element={<Game updateHeader={updateHeader}/>} />
        <Route path="/userpage" element={<UserPage updateHeader={updateHeader}/>} />
        <Route path="/plan" element={<UserPage updateHeader={updateHeader}/>} />
        <Route path="/ddd" element={<DDDUI updateHeader={updateHeader}/>} />
        <Route path="/admin" element={<Admin/>} />
        <Route path="/tournaments" element={<TournamentList updateHeader={updateHeader}/>} />
        <Route path="/tournament" element={<TournamentList updateHeader={updateHeader}/>} />
        <Route path="/tournamentStructure" element={<TournamentStructure updateHeader={updateHeader} />}/>
        <Route path="/allusers" element={<AllUsers updateHeader={updateHeader}/>} />
      </Routes>
      </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
